if(typeof _GIRL_CONF['indira']['game_memory']=='undefined'){_GIRL_CONF['indira']['game_memory']={};};
_GIRL_CONF['indira']['game_memory']['face']={left:581,top:116,width:165,height:156};
_GIRL_CONF['indira']['game_memory']['hair']={left:479,top:16,width:336,height:315};
_GIRL_CONF['indira']['game_memory']['hand']={left:472,top:304,width:364,height:390};
_GIRL_CONF['indira']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['indira']['game_memory']['item2']={left:868,top:370,width:146,height:293};
_GIRL_CONF['indira']['game_memory']['tit1']={left:547,top:347,width:131,height:125};
_GIRL_CONF['indira']['game_memory']['tit2']={left:667,top:358,width:81,height:103};
